import React from 'react';
import { InputAdornment, TextField, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';

export interface SearchFieldProps {
  value?: string;
  onChange: (value: string) => void;
  placeholder?: string;
  ariaLabel?: string;
  helperText?: React.ReactNode;
  sx?: SxProps<Theme>;
  className?: string;
  // for labels
  id?: string;
  onKeyDown?: (e: React.KeyboardEvent) => void;
  // 'full' = 100% everywhere. number = width (px) on desktop, 100% on mobile
  width?: 'full' | number;
}

const defaultSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 2,
    height: 40,
    '& .MuiOutlinedInput-input': {
      padding: '10px 14px',
    },
  },
};

export function SearchField({
  value,
  onChange,
  placeholder = 'Search',
  ariaLabel,
  helperText,
  sx,
  className,
  id,
  onKeyDown,
  width = 500,
}: SearchFieldProps) {
  const widthSx =
    width === 'full' ? { width: '100%' } : { width: { xs: '100%', md: width } };

  return (
    <div className={className} style={{ width: '100%' }}>
      <TextField
        id={id}
        variant="outlined"
        placeholder={placeholder}
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={onKeyDown}
        inputProps={{
          'aria-label': ariaLabel ?? placeholder,
        }}
        sx={{
          ...widthSx,
          ...defaultSx,
          ...(typeof sx === 'object' && sx !== null && !Array.isArray(sx)
            ? sx
            : {}),
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
      {helperText != null && (
        <Typography
          variant="body1"
          sx={{ lineHeight: '40px' }}
          className="table-cell align-middle"
        >
          {helperText}
        </Typography>
      )}
    </div>
  );
}
